import { hexToRGB } from '@/utils/color';
import { THEME_NAV_TEXT_COLOR, THEME_NAV_TEXT_COLOR_RESERVED, THEME_NAV_BJ_COLOR } from '@/constants/index';
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    backgroundColor: {
      type: String,
      default: '#ffffff'
    },
    opacity: {
      type: Number,
      default: 1 // 0:标题透明到不透明，1：标题始终不透明
    },

    onBack: {
      type: Function
    },
    border: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'default' // default/transparent
    },

    visibleHeight: {
      type: Boolean,
      default: true
    }
  },
  components: {},
  data() {
    return {
      scrollY: 0,
      scrollHeight: 60
    };
  },
  computed: {
    // isApp() {
    //   return false;
    // },
    statusBarRootStyles() {
      if (!this.isApp || !this.visibleHeight) {
        return {
          minHeight: 0,
          maxHeight: 0
        };
      }
      return {
        minHeight: `calc(${window.cfmoto.statusBarHeight()} + 44px)`
      };
    },
    statusBarWrapStyles() {
      const minHeight = `calc(${window.cfmoto.statusBarHeight()} + 44px)`;
      const paddingTop = window.cfmoto.statusBarHeight();
      return {
        minHeight,
        paddingTop
      };
    },
    alpha() {
      const {
        mode,
        scrollY
      } = this;
      if (mode === 'default') {
        return 1;
      }
      const opacity = (scrollY > this.scrollHeight ? this.scrollHeight : scrollY) / this.scrollHeight;
      if (scrollY < 10) return opacity;
      return opacity < 0.5 ? 0.5 : opacity;
    },
    rootStyles() {
      const display = this.isApp || this.$slots.right ? `block` : `none`; // app环境||right插槽存在内容
      return {
        display
      };
    },
    wrapStyles() {
      const position = this.isApp ? 'fixed' : 'relative';
      let background = this.backgroundColor;
      if (this.theme != 'light') {
        background = THEME_NAV_BJ_COLOR[this.theme];
      }
      if (this.mode === 'default') {
        let borderBottom = this.border ? `1px solid rgba(244, 245, 247, ${this.alpha})` : undefined;
        if (this.theme != 'light') {
          borderBottom = `0 solid ${THEME_NAV_BJ_COLOR[this.theme]}`;
        }
        return {
          position,
          backgroundColor: background,
          borderBottom
        };
      }
      let borderBottom = this.border && this.isApp ? `1px solid rgba(244, 245, 247, ${this.alpha})` : 'none';
      const backgroundColor = `rgba(${hexToRGB(background)},${this.alpha})`;
      if (this.theme != 'light') {
        borderBottom = `0 solid ${THEME_NAV_BJ_COLOR[this.theme]}`;
      }
      return {
        position,
        borderBottom,
        backgroundColor
      };
    },
    backStyles() {
      if (!this.isApp) {
        return {
          opacity: 0
        };
      }
      if (this.mode === 'default') {
        return {
          color: THEME_NAV_TEXT_COLOR[this.theme]
        };
      }
      if (this.opacity === 1) {
        return {
          color: this.backgroundColor === '#ffffff' ? THEME_NAV_TEXT_COLOR[this.theme] : THEME_NAV_TEXT_COLOR_RESERVED[this.theme]
        };
      }
      const color = this.alpha < 0.5 ? THEME_NAV_TEXT_COLOR_RESERVED[this.theme] : THEME_NAV_TEXT_COLOR[this.theme];
      const opacity = this.isApp ? 1 : 0; // app环境
      return {
        opacity,
        color
      };
    },
    titleStyles() {
      if (this.mode === 'default' || this.opacity === 1) {
        return {
          color: THEME_NAV_TEXT_COLOR[this.theme]
        };
      }
      const color = this.alpha < 0.5 ? THEME_NAV_TEXT_COLOR_RESERVED[this.theme] : THEME_NAV_TEXT_COLOR[this.theme];
      const opacity = !this.isApp || this.alpha < 0.5 ? 0 : 1; // 非app环境||自定义背景色
      return {
        color,
        opacity
      };
    },
    rightStyles() {
      if (this.theme != 'light') {
        return {
          color: THEME_NAV_TEXT_COLOR[this.theme]
        };
      }
      const color = this.alpha < 0.5 ? THEME_NAV_TEXT_COLOR_RESERVED[this.theme] : '#22D1FF ';
      const display = this.$slots.right ? 'flex' : 'flex'; // 如果right插槽存在内容
      return {
        display,
        color
      };
    },
    theme() {
      return this.$store.state.theme || ''; // 获取主题
    }
  },

  methods: {
    async handleBack() {
      if (this.onBack) {
        await this.onBack();
      }
      this.$router.back();
    },
    onPageScroll(e) {
      this.scrollY = e.target.scrollTop;
    }
  },
  created() {},
  mounted() {},
  beforeUnmount() {},
  watch: {}
};